import { AfterViewInit, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Player, TrackType } from 'fl-player-interface';
import { ResourceVm } from 'qp-ui-interface';
import { NavigationLibraryService } from '../../shared/services/navigation/navigation.service';
import { getAudioTrackList } from '../../shared/utils/PlaybackUtils';
export interface Track {
  type: TrackType;
  language: string;
  name: string;
  active: boolean;
}

@Component({
  selector: 'app-player-audio-subtitles-dialog',
  templateUrl: './player-audio-subtitles-dialog.component.html',
  styleUrls: ['./player-audio-subtitles-dialog.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlayerAudioSubtitlesComponent implements AfterViewInit {

  constructor(
    private dialogRef: MatDialogRef<PlayerAudioSubtitlesComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      currentResource: ResourceVm;
      player: Player;
    },
    private navService: NavigationLibraryService
  ) {}

  ngAfterViewInit(): void {
    if (this.data.player) {
      this.navService.setHorizontalIndex(0);
      let selectedAudio = getAudioTrackList(this.data.player).findIndex(track=>track.active);
      selectedAudio = selectedAudio >=0 ? selectedAudio : 0;
      this.navService.focusContainer('audio-container', false, selectedAudio);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
